import React, {  Component } from 'react';

export default class ConfirmManageUserDeleteUserDialogSuccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }
    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.handleDialog && this.props.handleDialog('ConfirmManageUserDeleteUserDialogSuccess', false);
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="emailSpecOverlayDialog1">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Delete User</h2>
					{this.props.deleteStatus
						? <p>Delete User request is received for the user <strong>{this.props.userDetails.firstName} {this.props.userDetails.lastName}</strong>. You will be notified shortly on the status of deletion via email.</p>
						: <p>Error in processing your delete user request. Please call customer care.</p>
					}
					<form className="emailSpecForm" onSubmit={this.closeDialog.bind(this)}>
                       <div className="floatRight">
                          <input className="blueButton" type="submit" value="OK" />
                       </div>
                       <div className="clear" />
                    </form>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/confirmManageUserDeleteUserDialogSuccess.js